/** Normaliza una URL de navegación (sin query, fragment ni barra final). */
export function normalizeNavUrl(url: string): string {
  return url.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
}

type NavUrlTree = {
  url?: string;
  menu?: NavUrlTree[];
};

/** Recoge todas las URLs configuradas en sidenav/topnav (incluye submenús). */
export function collectNavUrls(items: readonly NavUrlTree[]): string[] {
  const urls: string[] = [];

  for (const item of items) {
    if (item.url) {
      urls.push(normalizeNavUrl(item.url));
    }
    if (item.menu?.length) {
      urls.push(...collectNavUrls(item.menu));
    }
  }

  return urls;
}

/**
 * Resuelve la URL de menú que debe marcarse como activa para la ruta actual.
 * Prefiere la coincidencia más específica (p. ej. `/configuracion/usuarios` sobre `/configuracion`).
 */
export function resolveNavHighlightUrl(currentUrl: string, navUrls: readonly string[]): string {
  const current = normalizeNavUrl(currentUrl);
  let bestMatch: string | null = null;

  for (const rawUrl of navUrls) {
    const candidate = normalizeNavUrl(rawUrl);
    if (current === candidate || current.startsWith(`${candidate}/`)) {
      if (!bestMatch || candidate.length > bestMatch.length) {
        bestMatch = candidate;
      }
    }
  }

  return bestMatch ?? current;
}
